export const REQUEST_PRODUCTION_STEPS_STATS = "request_production_steps_stats";
export const RECEIVE_PRODUCTION_STEPS_STATS = "receive_production_steps_stats";
export const PRODUCTION_STEPS_STATS_ERROR = "production_steps_stats_error";

import { getProductionStepsStats } from "src/actions/randomActions";

const receiveProductionStepsStats = () => {
	return async dispatch => {
		const onRequest = () => {
			dispatch({
				//dipatch request string to be handled by reducer
				type: REQUEST_PRODUCTION_STEPS_STATS,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string to be handled by reducer
				type: RECEIVE_PRODUCTION_STEPS_STATS,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string to be handled by reducer
				type: PRODUCTION_STEPS_STATS_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			// make api request
			const { data } = await getProductionStepsStats();
			const { productionStepsStats } = data;
			return onSuccess(productionStepsStats);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

export { receiveProductionStepsStats };
